export default __webpack_public_path__ + "static/media/Headdress of the Hell Walker (nm).bbaefcf7.jpg";